import React, { useState, useImperativeHandle, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/header.css";

const SearchLocation = forwardRef(
  (
    {
      cb,
      className,
      panelMode = false,
      onSuggestionsChange,
      onQueryChange,
      onPlaceSelect,
    },
    ref,
  ) => {
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();

    const updateSuggestions = (list) => {
      setSuggestions(list);
      onSuggestionsChange?.(list);
    };

    const handleInputChange = (e) => {
      const inputValue = e.target.value;
      setQuery(inputValue);
      onQueryChange?.(inputValue);

      if (!inputValue || inputValue.length < 2) {
        updateSuggestions([]);
        return;
      }

      if (!window.google?.maps?.places) {
        updateSuggestions([]);
        return;
      }

      const autoCompleteService =
        new window.google.maps.places.AutocompleteService();
      autoCompleteService.getPlacePredictions(
        { input: inputValue, componentRestrictions: { country: "IN" } },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            updateSuggestions(predictions || []);
          } else {
            updateSuggestions([]);
          }
        },
      );
    };

    const handlePlaceSelect = (place) => {
      if (!window.google?.maps?.places) return;

      const placeService = new window.google.maps.places.PlacesService(
        document.createElement("div"),
      );
      placeService.getDetails({ placeId: place.place_id }, (result, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setQuery("");
          updateSuggestions([]);
          onQueryChange?.("");
          onPlaceSelect?.();

          if (cb == undefined) {
            navigate(`/all-facilities`, {
              state: {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng(),
              },
            });
          } else {
            cb({
              coords: {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng(),
              },
              result,
            });
          }
        }
      });
    };

    useImperativeHandle(ref, () => ({
      selectPlace: handlePlaceSelect,
    }));

    const showInlineSuggestions =
      !panelMode && query !== "" && query.length > 1 && suggestions.length > 0;

    return (
      <div className={`search-container-head ${className ? className : ""}`}>
        <div className="input-group search-bar-wrapper">
          <svg
            style={{
              position: "absolute",
              left: "5px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "20px",
              height: "20px",
              fill: "#888",
            }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
          <input
            type="search"
            value={query}
            onChange={handleInputChange}
            className="form-control"
            id="globalSearch"
            placeholder="Search for cities, places..."
            aria-label="Search for cities, places..."
            aria-describedby="global-search"
            style={{ paddingLeft: "30px" }}
          />
          {showInlineSuggestions ? (
            <ul className="suggestionList">
              {suggestions.map((suggestion) => {
                let suggetionData = [];

                if (suggestion.description.includes(",")) {
                  suggetionData = suggestion.description.split(",", 1);
                }

                return (
                  <React.Fragment key={suggestion.place_id}>
                    {suggetionData.length === 2 ? (
                      <li
                        onClick={() => handlePlaceSelect(suggestion)}
                        className="suggestion-item"
                      >
                        <p className="suggestion-heading">{suggetionData[0]}</p>
                        <p className="suggestion-desc">{suggetionData[1]}</p>
                      </li>
                    ) : (
                      <li
                        onClick={() => handlePlaceSelect(suggestion)}
                        className="suggestion-item"
                      >
                        <p className="suggestion-heading">
                          {suggestion.description}
                        </p>
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          ) : null}
        </div>
      </div>
    );
  },
);

SearchLocation.displayName = "SearchLocation";

export default SearchLocation;
